(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["callidus-grid-solar-proof"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cgs-proof-slider')) {
    class CgsProofSlider extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.track = this.querySelector('.cgs-proof__track');
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.status = this.querySelector('[data-status]');
        this.navigation = this.querySelector('.cgs-proof__navigation');
        this.desktopColumns = Number(this.dataset.desktopColumns) || 1;
        this.index = 0;
        this.touchStartX = 0;
        this.touchEndX = 0;

        if (this.initialized) return;

        this.initialized = true;
        this.querySelectorAll('[data-read-more]').forEach((button) => {
          button.addEventListener('click', () => this.toggleReview(button));
        });

        if (this.slides.length < 2) return;

        this.querySelector('[data-previous]').addEventListener('click', () => this.show(this.index - 1, true));
        this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1, true));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.dot))));
        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.show(this.index - 1, true);
          }
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.show(this.index + 1, true);
          }
        });
        this.addEventListener('touchstart', (event) => {
          this.touchStartX = event.changedTouches[0].clientX;
        }, { passive: true });
        this.addEventListener('touchend', (event) => {
          this.touchEndX = event.changedTouches[0].clientX;
          const distance = this.touchStartX - this.touchEndX;
          if (Math.abs(distance) > 50) this.show(this.index + (distance > 0 ? 1 : -1), true);
        }, { passive: true });
        this.addEventListener('shopify:block:select', (event) => {
          const selectedIndex = this.slides.indexOf(event.target);
          if (selectedIndex > -1) this.show(selectedIndex);
        });
        this.resizeObserver = new ResizeObserver(() => this.show(this.index));
        this.resizeObserver.observe(this);
        this.show(0);
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      getVisibleCount() {
        if (window.matchMedia('(max-width: 700px)').matches) return 1;
        if (window.matchMedia('(max-width: 1100px)').matches) return Math.min(2, this.desktopColumns);
        return Math.min(this.desktopColumns, this.slides.length);
      }

      show(nextIndex, wrap = false) {
        const visibleCount = this.getVisibleCount();
        const maxIndex = Math.max(0, this.slides.length - visibleCount);

        if (wrap && nextIndex < 0) nextIndex = maxIndex;
        if (wrap && nextIndex > maxIndex) nextIndex = 0;

        this.index = Math.max(0, Math.min(nextIndex, maxIndex));
        this.track.style.transform = `translate3d(-${this.slides[this.index].offsetLeft}px, 0, 0)`;
        this.slides.forEach((slide, index) => {
          slide.setAttribute('aria-hidden', index < this.index || index >= this.index + visibleCount);
        });
        this.dots.forEach((dot, index) => {
          dot.hidden = index > maxIndex;
          if (index === this.index) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
        if (this.navigation) this.navigation.hidden = maxIndex === 0;
        if (this.status) {
          const lastVisible = Math.min(this.index + visibleCount, this.slides.length);
          this.status.textContent = `Reviews ${this.index + 1}–${lastVisible} of ${this.slides.length}`;
        }
      }

      toggleReview(button) {
        const review = button.closest('[data-slide]');
        const excerpt = review.querySelector('[data-review-excerpt]');
        const full = review.querySelector('[data-review-full]');
        const expanded = button.getAttribute('aria-expanded') === 'true';

        excerpt.hidden = !expanded;
        full.hidden = expanded;
        button.setAttribute('aria-expanded', String(!expanded));
        button.textContent = expanded ? button.dataset.moreLabel : button.dataset.lessLabel;
      }
    }

    customElements.define('cgs-proof-slider', CgsProofSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["callidus-navigation"] && !Shopify.designMode) return;
  try {
    
  if (window.location.host === 'engineering.callidus.shop') {
    document.documentElement.classList.add('has-callidus-navigation');

    document.querySelectorAll('[data-callidus-nav]').forEach(function (nav) {
      var button = nav.querySelector('.callidus-nav-toggle');
      var menu = nav.querySelector('.callidus-menu');

      if (!button || !menu) return;

      button.addEventListener('click', function () {
        var open = button.getAttribute('aria-expanded') === 'true';

        button.setAttribute('aria-expanded', String(!open));
        menu.classList.toggle('is-open', !open);
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-reviews"] && !Shopify.designMode) return;
  try {
    
// No additional JavaScript required

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["voltage-drop-calculator"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const calculateButton = document.getElementById('calculate-button');
    calculateButton.addEventListener('click', function () {
      // Debugging check
      console.log('Calculate button clicked');

      const cableArea = document.getElementById('cable_area').value;
      const supplyVoltage = parseFloat(document.getElementById('supply_voltage').value);
      const currentDraw = parseFloat(document.getElementById('current_draw').value);
      const circuitLength = parseFloat(document.getElementById('circuit_length').value);

      // Debugging check
      console.log(`Inputs - Cable Area: ${cableArea}, Supply Voltage: ${supplyVoltage}, Current Draw: ${currentDraw}, Circuit Length: ${circuitLength}`);

      // Resistance per meter values based on provided cable cross-section in ohms/meter
      const resistancePerMeter = {
        "0.35": 0.0544,
        "0.50": 0.03710,
        "0.75": 0.0247,
        "1.00": 0.01850,
        "1.50": 0.01270,
        "2.00": 0.00942,
        "2.50": 0.00760,
        "3.00": 0.00615,
        "4.00": 0.00471,
        "6.00": 0.00314,
        "8.50": 0.00220,
        "10.00": 0.00182,
        "16.00": 0.00126,
        "25.00": 0.00077,
        "35.00": 0.00056,
        "50.00": 0.00039,
        "70.00": 0.00029,
        "95.00": 0.00020,
        "120.00": 0.00015
      };

      const resistance = resistancePerMeter[cableArea];
      const roundTripLength = circuitLength * 2;

      // Voltage Drop calculation
      const voltageDrop = (currentDraw * resistance * roundTripLength).toFixed(2);
      const voltageDropPercent = ((voltageDrop / supplyVoltage) * 100).toFixed(1);

      // Suitability check
      let suitabilityMessage = '';
      let suitabilityClass = '';
      if (voltageDropPercent <= 4) {
        suitabilityMessage = 'This cable size is suitable (within the 3-4% maximum recommended voltage drop).';
        suitabilityClass = 'suitability';
      } else {
        suitabilityMessage = 'This cable size is NOT suitable (exceeds the recommended 3-4% maximum voltage drop).';
        suitabilityClass = 'not-suitable';
      }

      // Display results
      document.querySelector('.result').innerHTML = `
        <p>The voltage drop is ${voltageDropPercent}% (${voltageDrop} volts).</p>
        <p>Calculated using a resistance of ${resistance}Ω per metre for the cable, and a total round-trip circuit length of ${roundTripLength} metres.</p>
        <p class="${suitabilityClass}">${suitabilityMessage}</p>
      `;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
